import { Typography, Box } from "@mui/material";

import { AppFormType } from "components/Forms/AppForm";

interface PublishSelectSectionProps {
  productForm: AppFormType | { AppField: any; Subscribe: any };
}

const PublishSelectSection = ({ productForm }: PublishSelectSectionProps) => {
  return (
    <productForm.Subscribe
      selector={(state: any) => state.values.submissionType.is_resubmission}
    >
      {(is_resubmission: boolean) => (
        <Box className="mb-4">
          <Typography variant="body1" className="mb-2">
            VENDOR&apos;S APPROVAL
          </Typography>
          <div className="border p-3 rounded">
            {is_resubmission && (
              <Box className="mb-3 p-2 bg-yellow-50 border-l-4 border-yellow-400">
                <Typography
                  variant="body2"
                  className="text-yellow-800 font-medium"
                >
                  PER NIAP POLICY, RESUBMITTED EVALUATIONS ARE NOT ELIGIBLE TO
                  BE LISTED ON THE IN-EVALUATION LIST ON THE NIAP WEBSITE.
                </Typography>
              </Box>
            )}
            <productForm.AppField name="publish_status">
              {(field: any) => (
                <field.RadioButton
                  label="Vendor's approval to be listed on NIAP In Evaluation:"
                  isHorizontal
                  disabled={is_resubmission}
                  options={[
                    {
                      label: "DO NOT LIST on NIAP CCEVS website",
                      value: "Unpublished",
                    },
                    {
                      label: "LIST on NIAP CCEVS website",
                      value: "Published",
                    },
                  ]}
                />
              )}
            </productForm.AppField>
          </div>
        </Box>
      )}
    </productForm.Subscribe>
  );
};

export default PublishSelectSection;
